import { gql } from 'apollo-angular';
import { paginationFragment } from '@services/queries/fragments/lighthouse.fragments';

export const carriersQuery = gql`
  query Carriers(
    $page: Int
    $size: Int!
    $where: QueryCarriersWhereWhereConditions
    $orderBy: [QueryCarriersOrderByOrderByClause!]
  ) {
    carriers(page: $page, first: $size, where: $where, orderBy: $orderBy) {
      data {
        id
        name
        mcNumber
        dotNumber
      }
      paginatorInfo {
        ...PaginationFragment
      }
    }
  }
  ${paginationFragment}
`;
